import { makeApi } from "@zodios/core";
import { z } from "zod";

import { loginBodySchema } from "@/data/api/kili/security/security.type";

export const securityApi = makeApi([
  {
    method: "post",
    path: "/login",
    response: z.unknown(), // 200 ok
    alias: "login",
    parameters: [
      {
        type: "Body",
        name: "body",
        schema: loginBodySchema,
      },
    ],
  },
  {
    method: "post",
    path: "/logout",
    response: z.unknown(), // 200 ok
    alias: "logout",
  },
]);
